import React from 'react';
import SpoilerInfo from '../common/SpoilerInfo.jsx';
import { projectName } from '../../../../config';
import { Link } from 'react-router-dom';

const CartInfo = (props) => {
  return <SpoilerInfo title={ gettext('Информация для покупателей') }>
      <div>
        <p className="font-weight-bold">
          { gettext('Внимание! На сайте предусмотрена система скидок при единовременной покупке нескольких товаров!') }
        </p>
        <ul>
          <li>3 { gettext('товара') }: 5%</li>
          <li>5 { gettext('товаров') }: 7%</li>
          <li>10 { gettext('товаров') }: 10%</li>
          <li>20 { gettext('товаров') }: 20%</li>
        </ul>
        <p>{ gettext('Если товар продается со скидкой, то скидка за единовременную покупку нескольких товаров на нее не распростроняется.') }</p>
        <p>{ gettext('После оплаты вы сразу же получите выбранные товары по электронной почте. Также они всегда будут доступны в вашем личном кабинете на ')
        + projectName + ' ' + gettext('в разделе') + ' ' }
        <Link to={'/' + props.lang + '/my/purchases/'}>{ gettext('"Мои Покупки"') }</Link>.</p>
      </div>
  </SpoilerInfo>;
};

export default CartInfo;